import { datadogLogs } from '@datadog/browser-logs';
import { sha256 } from 'js-sha256';

export const readFileAsArrayBuffer = (file: File): Promise<ArrayBuffer> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      if (reader.result instanceof ArrayBuffer) {
        resolve(reader.result);
      } else {
        reject(new Error('Failed to read file as ArrayBuffer'));
      }
    };
    reader.onerror = () => reject(reader.error ?? new Error('Unknown FileReader error'));
    reader.readAsArrayBuffer(file);
  });
};

export const calculateFileSHA = async (file: File): Promise<string> => {
  try {
    const arrayBuffer = await readFileAsArrayBuffer(file);
    const uint8Array = new Uint8Array(arrayBuffer);

    // Convert Uint8Array to string for sha function
    let binary = 'outside_inventory_';
    for (let i = 0; i < uint8Array.length; i++) {
      binary += String.fromCharCode(uint8Array[i]);
    }

    return sha256.create().update(binary).hex();
  } catch (error) {
    datadogLogs.logger.error(
      'Error calculating SHA:',
      error instanceof Error ? { message: error.message, stack: error.stack } : { error }
    );
    throw error;
  }
};

export const getFileMimeType = (file: File): string => {
  return file.type || 'application/octet-stream';
};
